import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnitTypeService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllUnitType(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.UnitType,
      queryString:`Page=${page}&Size=${size}&Search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async updateUnitType(id,unitTypeName){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.UnitType
    },{
      id:id,
      unitTypeName:unitTypeName
    });
    return await firstValueFrom(observable);
  }

  async createUnitType(unitTypeName){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.UnitType
    },{
      unitTypeName:unitTypeName
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
